import { render, staticRenderFns } from "./pe-manage.vue?vue&type=template&id=0ecb6a18&scoped=true"
import script from "./pe-manage.vue?vue&type=script&lang=js"
export * from "./pe-manage.vue?vue&type=script&lang=js"
import style0 from "./pe-manage.vue?vue&type=style&index=0&id=0ecb6a18&prod&lang=scss"
import style1 from "./pe-manage.vue?vue&type=style&index=1&id=0ecb6a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@5.2.7_prettier@2.8.7_react-dom@17.0.2_react@_xbvnx5joxenxrdtaq55cnp74na/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb6a18",
  null
  
)

export default component.exports